import { render, staticRenderFns } from "./SmallPercentInput.vue?vue&type=template&id=6c0aeb68&scoped=true"
import script from "./SmallPercentInput.vue?vue&type=script&lang=js"
export * from "./SmallPercentInput.vue?vue&type=script&lang=js"
import style0 from "./SmallPercentInput.vue?vue&type=style&index=0&id=6c0aeb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0aeb68",
  null
  
)

export default component.exports